var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgXIcon = function SvgXIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none",
    viewBox: "0 0 33 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BFBFBF",
    stroke: "#BFBFBF",
    strokeWidth: 0.5,
    d: "m19.295 13.756 10.92-12.423h-2.587l-9.487 10.784-7.572-10.783H1.834l11.453 16.308L1.834 30.667h2.588l10.012-11.39 7.998 11.39h8.735zm-3.546 4.029-1.162-1.625L5.355 3.242H9.33l7.453 10.429 1.157 1.625 9.687 13.555h-3.975z"
  })));
};
export default SvgXIcon;